import {
  MotifHeader,
  MotifHeaderLogo,
  MotifIcon,
  MotifIconButton,
  MotifAvatar,
  MotifTooltip,
} from "@ey-xd/motif-react";
import {
  IconoirCart,
  IconoirLogOut,
  IconoirChatBubbleQuestion,
  IconoirRefresh,
} from "@ey-xd/motif-icon";
import { useSelector } from "react-redux";
import { RootState } from "../../store";
import "./Header.scss";
import Button from "../Button/Button";
import { getUserLogout } from "../../store/slices/UserLogoutSlice";
import eyLogo from "../../assets/images/ey_logo_default.svg";
import { useNavigate } from "react-router";
import { removeOpportunityCodeFromLocal } from "../../utils/common";
import { updateShowDiscardModalState } from "../../store/slices/CheckoutSlice";
import { useAppDispatch } from "../../store/hooks";
import MaintenanceWindow from "../MaintenanceWindow";
import { useState, useEffect } from "react";

const Header: React.FC = () => {
  const enableServiceNow = import.meta.env.VITE_ENABLE_SN;
  const [showServiceNowEM, setShowServiceNowEM] = useState(false);
  const ecEmbedWrapper = document.querySelector("div.ecEmbedWrapper");

  useEffect(() => {
    const em_iframe = document.getElementById("em_iframe");
    em_iframe?.addEventListener("load", () => {
      setTimeout(() => {
        setShowServiceNowEM(true);
      }, 7000);
    });

    if (document.getElementById("ecLauncherFloatingBubble")) {
      if (!showServiceNowEM) {
        setTimeout(() => {
          setShowServiceNowEM(true);
        }, 7000);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ecEmbedWrapper]);

  const name: string = useSelector(
    (state: RootState) => state.UserProfileSlice.name,
  );
  const avatar: string = useSelector(
    (state: RootState) => state.UserProfileSlice.avatar,
  );

  const emailId: string = useSelector(
    (state: RootState) => state.UserProfileSlice.emailId,
  );

  const isEstimateChanged =
    useSelector((state: RootState) => state.CheckoutSlice.isEstimateChanged) ||
    false;

  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const handleClick = (path: string) => {
    if (isEstimateChanged) {
      sessionStorage.setItem("redirectTo", path);
      dispatch(updateShowDiscardModalState(true));
    }
    if (!isEstimateChanged) {
      dispatch(updateShowDiscardModalState(false));
      navigate(path);
    }
  };

  const handleEMClick = () => {
    const ecEmbedWrapper = document.querySelector("div.ecEmbedWrapper");

    if (
      ecEmbedWrapper?.classList.contains("dockIn") &&
      typeof window.SN_CSM_EC?.close === "function"
    ) {
      window.SN_CSM_EC.close();
    } else {
      if (typeof window.SN_CSM_EC?.open === "function") {
        window.SN_CSM_EC.open();
      }
    }
  };

  const handleLogout = async () => {
    const cleanUrl = window.location.origin + "/";
    window.history.replaceState({}, document.title, cleanUrl);
    dispatch(getUserLogout());
    dispatch(updateShowDiscardModalState(false));
    removeOpportunityCodeFromLocal();
    sessionStorage.removeItem("redirectTo");

    if (
      typeof window.SN_CSM_EC !== "undefined" &&
      typeof window.SN_CSM_EC.hide === "function"
    ) {
      window.SN_CSM_EC.hide();
      window.SN_CSM_EC?.close();
    }
  };

  const handleLogoutClick = () => {
    if (isEstimateChanged) {
      sessionStorage.setItem("redirectTo", "/");
      dispatch(updateShowDiscardModalState(true, true));
    } else {
      handleLogout();
    }
  };

  return (
    <div className="motif-no-padding">
      <MotifHeader
        className="header"
        appHeaderName=""
        fixed={false}
        logo={
          <MotifHeaderLogo>
            <a
              aria-label="EY Logo - Home"
              href="/"
              onClick={(e) => {
                e.preventDefault();
                handleClick("/");
              }}
            >
              <img src={eyLogo} alt="EY logo" />
              <span className="motif-header-app-name" title="">
                Commercial Hub
              </span>
            </a>
          </MotifHeaderLogo>
        }
        rightComponents={
          <>
            {enableServiceNow === "true" && (
              <>
                {showServiceNowEM ? (
                  <MotifTooltip
                    contentClassName="tooltip-content"
                    allowClick={false}
                    allowHover
                    hideCloseButton
                    placement="left"
                    trigger={
                      <MotifIconButton
                        aria-label="Support"
                        size="medium"
                        type="button"
                        onClick={() => handleEMClick()}
                      >
                        <MotifIcon iconFunction={IconoirChatBubbleQuestion} />
                      </MotifIconButton>
                    }
                  >
                    Support
                  </MotifTooltip>
                ) : (
                  <MotifTooltip
                    contentClassName="tooltip-content"
                    allowClick={false}
                    allowHover
                    hideCloseButton
                    placement="left"
                    trigger={
                      <MotifIconButton
                        aria-label="Support"
                        size="medium"
                        type="button"
                        disabled
                      >
                        <MotifIcon
                          iconFunction={IconoirRefresh}
                          className="iconoir-refresh-circular"
                        />
                      </MotifIconButton>
                    }
                  >
                    Loading
                  </MotifTooltip>
                )}
              </>
            )}

            <MotifIconButton
              aria-label="Cart"
              size="medium"
              type="button"
              onClick={() => handleClick("/checkout")}
            >
              <MotifIcon iconFunction={IconoirCart} />
            </MotifIconButton>

            <MotifTooltip
              contentClassName="tooltip-content"
              id={"tooltip-user-panel"}
              allowClick
              allowHover
              hideArrow
              trigger={
                <MotifAvatar
                  aria-label="User Avatar"
                  size="small"
                  description="UserName name.use@ey.com"
                  src={avatar}
                  userName={name}
                />
              }
            >
              <>
                <div className="user-panel-avatar">
                  <MotifAvatar
                    aria-label="User Avatar"
                    size="small"
                    description="UserName name.use@ey.com"
                    src={avatar}
                    userName={name}
                  />
                  <div>
                    <div className="user-panel-avatar-username">{name}</div>
                    <div className="user-panel-avatar-email">{emailId}</div>
                  </div>
                </div>
                <div className="logout-wrapper">
                  <MotifIcon iconFunction={IconoirLogOut} size="24" />

                  <div className="logout-icon">
                    <Button
                      onClickHandler={handleLogoutClick}
                      label="Log Out"
                      variant="secondary"
                      className="logout-btn"
                    />
                  </div>
                </div>
              </>
            </MotifTooltip>
          </>
        }
      />
      <MaintenanceWindow />
    </div>
  );
};

export default Header;
